<template>
  <div class="register-page">
    <b-container class="d-flex justify-content-center align-items-center h-100">
      <div v-if="needsVerification">
        <div v-if="alreadyRegistered">
          <b-card class="register-card text-center" header="Success" header-tag="h2">
            <p class="text-center">You are already registered, We have resent the verification email, Please click on the link to verify</p>
          </b-card>
        </div>
        <div v-else>
          <b-card class="register-card text-center" header="Success" header-tag="h2">
            <p class="text-center">Thank you for registering! Please check your email to verify your account.</p>
          </b-card>
        </div>
      </div>
      <div v-else>
        <b-card class="register-card" header="Register" header-tag="h2">
          <b-form @submit.prevent="registerUser">
            <b-form-group label="Email" label-for="email">
              <b-form-input
                v-model="email"
                type="email"
                id="email"
                required
                placeholder="Enter your email"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Organization" label-for="organization">
              <b-form-input
                v-model="organization"
                type="text"
                id="organization"
                required
                placeholder="Organization name eg: 'Cloud-AM'"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Password" label-for="password">
              <b-form-input
                v-model="password"
                type="password"
                id="password"
                required
                placeholder="Enter your password"
                @input="validatePassword"
              ></b-form-input>
              <b-form-text v-if="passwordError" class="text-danger">
                {{ passwordError }}
              </b-form-text>
            </b-form-group>

            <b-button class="btn-fill" type="submit" variant="primary" block :disabled="passwordError">
              Register
            </b-button>
          </b-form>


          <div class="login-prompt text-center mt-3">
            <p>Already have a Cloud AM account?
              <b-link @click="goToLogin">Login instead</b-link>
            </p>
          </div>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
import apiClient from "@/http";

export default {
  data() {
    return {
      email: '',
      password: '',
      organization: '',
      passwordError: null,
      needsVerification: false,
      alreadyRegistered: false
    };
  },
  methods: {
    validatePassword() {
      const password = this.password;
      const hasNumber = /\d/;
      const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;

      if (password.length < 8) {
        this.passwordError = 'Password must be at least 8 characters long.';
      } else if (!hasNumber.test(password)) {
        this.passwordError = 'Password must contain at least one number.';
      } else if (!hasSymbol.test(password)) {
        this.passwordError = 'Password must contain at least one symbol.';
      } else {
        this.passwordError = null;
      }
    },
    async registerUser() {
      try {
        let response = await apiClient.post('/auth/registration', {
          email: this.email,
          password: this.password,
          organization: this.organization
        });
        this.needsVerification = true;
      } catch (error) {
        if (error.response.status === 428) {
          this.needsVerification = true;
          this.alreadyRegistered = true;
        } else {
          const errorMessage = error.response && error.response.data ? error.response.data : 'An error occurred. Please try again.';
          this.$bvToast.toast(errorMessage, {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }

      }
    },
    goToLogin() {
      this.$router.push('/sign-in');
    }
  }
};
</script>

<style scoped>
.register-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.register-card {
  max-width: 400px;
  width: 100%;
  padding: 20px;
  border-radius: 8px;
}

.login-prompt {
  font-size: 14px;
  color: #666;
}

.login-prompt b-link {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
